import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TieTimingRecordModel extends Model 
{
	@attr order;
	
	@belongsTo('event', {inverse: 'tieTimingRecords', async: true}) EventId;
	@belongsTo('entry', {inverse:'TieTimingRecordId', async: true}) EntryId;
}